import Card from '@mui/material/Card';
import { CCardProps } from 'types/atoms';
import customTwMerge from 'utils/twMerge';

export default function CCard({
  className,
  children,
  isBorderX,
  isBorderPrimary,
  isBorderSecondary,
  onClick,
}: CCardProps) {
  return (
    <Card
      className={customTwMerge(
        'rounded-xl shadow-sm',
        isBorderX && 'border-x-2 border-primary-200',
        isBorderPrimary && 'border border-primary-100',
        isBorderSecondary && 'border-2 border-secondary-800',
        className
      )}
      onClick={onClick}
    >
      {children}
    </Card>
  );
}
